import { graphql } from '../../graphql';

export const createInteractionMutation = graphql(`
  mutation CreateInteraction(
    $targetId: ID!
    $sourceLink: String
    $triggerButton: String
    $phones: [String!]
    $targetType: InteractionTargetTypeEnum!
    $eventType: InteractionEventTypeEnum!
    $source: InteractionSourceEnum!
  ) {
    createInteraction(
      input: {
        targetId: $targetId
        targetType: $targetType
        sourceLink: $sourceLink
        triggerButton: $triggerButton
        phones: $phones
        eventType: $eventType
        source: $source
      }
    ) {
      errors {
        code
        message
        path
      }
    }
  }
`);
